import React, { useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import "./sitePages.css";
import "./contact.css";

const CONTACT_API_URL =
  process.env.REACT_APP_SITE_CONTACT_API_URL || "http://localhost:8000/api/site/devis/";

function Contact({ embedded = false }) {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    need: "",
    message: "",
  });
  const [submitState, setSubmitState] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitState({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      const response = await axios.post(CONTACT_API_URL, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setSubmitState({
        type: "success",
        message:
          response.data?.message ||
          "Votre demande a bien ete envoyee. Nous vous recontacterons rapidement.",
      });
      setFormData({
        name: "",
        company: "",
        email: "",
        need: "",
        message: "",
      });
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Une erreur s'est produite pendant l'envoi. Veuillez reessayer.";
      setSubmitState({ type: "error", message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="content-page">
      {!embedded && <Header />}

      <main className="content-main">
        <section className="page-hero">
          <h1>Contact / Audit gratuit</h1>
          <p>
            Partagez votre besoin et recevez un premier cadrage
            strat&eacute;gique de votre projet.
          </p>
        </section>

        <section className="content-block contact-block">
          <div className="contact-panel">
            <h2>Demander un audit</h2>
            <form className="audit-form" onSubmit={handleSubmit}>
              <label htmlFor="name">Nom complet</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Votre nom"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label htmlFor="company">Entreprise / &Eacute;tablissement</label>
              <input
                id="company"
                name="company"
                type="text"
                placeholder="Nom de votre structure"
                value={formData.company}
                onChange={handleChange}
                required
              />

              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="exemple@domaine.com"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="need">Besoin principal</label>
              <select id="need" name="need" value={formData.need} onChange={handleChange} required>
                <option value="" disabled>
                  S&eacute;lectionnez une option
                </option>
                <option>Digitalisation</option>
                <option>Infrastructure IT</option>
                <option>Approvisionnement bureautique</option>
                <option>Smart-Educka</option>
              </select>

              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="D&eacute;crivez vos objectifs..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              {submitState.message ? (
                <div className={`audit-form-notice ${submitState.type}`}>
                  {submitState.message}
                </div>
              ) : null}

              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Envoi en cours..." : "Envoyer la demande"}
              </button>
            </form>
          </div>
        </section>
      </main>

      {!embedded && <Footer />}
    </div>
  );
}

export default Contact;
